import { FC, ReactNode } from "react";
import { Box, Button, Stack } from "@mui/material";
import AtmSvg from "@/assets/svg/AtmSvg";
import CheckSvg from "@/assets/svg/CheckSvg";
import theme from "@/theme";
import { stylesArticleInfoPanel as style } from "./stylesArticleInfoPanel";

export interface IArticleValidationState {
  hasTitle: boolean;
  hasSummary: boolean;
  hasSubtype: boolean;
}

interface IArticleInfoPanelProps {
  validationState: IArticleValidationState;
  onHide: () => void;
}

const Requirement: FC<{ done: boolean; children: ReactNode }> = ({ done, children }) => (
  <Stack direction="row" alignItems="center" gap="1px">
    <Box sx={style.checkWrapper}>
      <CheckSvg
        width={20}
        height={20}
        color={done ? theme.palette.custom.secondaryGreenLight : theme.palette.custom.blueGray600}
      />
    </Box>
    <Box sx={style.requirementText(done)}>{children}</Box>
  </Stack>
);

const ArticleInfoPanel: FC<IArticleInfoPanelProps> = ({ validationState, onHide }) => {
  return (
    <Box sx={style.container}>
      <Stack sx={style.content}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ width: "100%" }}
        >
          <Stack direction="row" alignItems="center" gap="8px">
            <AtmSvg color="primary" width={24} height={24} />
            <Box sx={style.title}>To publish an article, you need:</Box>
          </Stack>
          <Button variant="text" color="primary" onClick={onHide} sx={style.hideButton}>
            Hide
          </Button>
        </Stack>

        <Stack sx={style.list}>
          <Requirement done={validationState.hasTitle}>
            Add a title — Your article must have a clear, descriptive title.
          </Requirement>

          <Requirement done={validationState.hasSummary}>
            Write a summary Include relevant{" "}
            <Box component="span" sx={style.accent}>
              $cashtags (e.g. $AAPL, $TSLA).
            </Box>
          </Requirement>

          <Requirement done={validationState.hasSubtype}>
            Select{" "}
            <Box component="span" sx={style.accent}>
              #fundamental
            </Box>{" "}
            or{" "}
            <Box component="span" sx={style.accent}>
              #technical
            </Box>{" "}
            or both.
          </Requirement>
        </Stack>
      </Stack>
    </Box>
  );
};

export default ArticleInfoPanel;
